module.exports = __webpack_public_path__ + "static/media/bambus.52a573df.jpg";